import React from 'react';

export const SidebarCollapseContext = React.createContext<{ collapsed: boolean }>({ collapsed: false });
